module.exports = __webpack_public_path__ + "img/profile-trend.48f2925b.png";